module.exports = "/work-site/img/pdf.b43b10a7.png";